"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../../assets/css/CategoryProductManagement.min.css";
import html2canvas from "html2canvas";
import html2pdf from 'html2pdf.js';

export default function Orders ({ searchQuery = "", onSectionChange }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDetails, setOrderDetails] = useState(null);
    const [editQuantity, setEditQuantity] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://leapatinternational.com/admin/api/v1/get_all_orders.php");

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                setData(result.orders);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Get order details for modal
    const getOrderDetails = async (orderId) => {
        try {
            setModalLoading(true);
            const data = new FormData();
            data.append("order_id", orderId);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/get_order_details.php", {
                method: "POST",
                body: data
            });

            const result = await response.json();

            if (result.status === "success") {
                setOrderDetails(result.data);
                setEditQuantity(result.data.quantity || "");
            } else {
                toast.error("Failed to fetch order details");
            }
        } catch (error) {
            console.error("Error fetching order details:", error);
            toast.error("Error fetching order details");
        } finally {
            setModalLoading(false);
        }
    };

    // Update order status (approve/reject)
    const updateOrderStatus = async (orderId, status) => {
        try {
            const data = new FormData();
            data.append("order_id", orderId);
            data.append("status", status);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/update_order_status.php", {
                method: "POST",
                body: data
            });

            const result = await response.json();

            if (result.status === "success") {
                toast.success(`Order ${status === "1" ? "approved" : "rejected"} successfully`);
                // Refresh the orders list
                window.location.reload();
            } else {
                toast.error(result.message || "Failed to update order status");
            }
        } catch (error) {
            console.error("Error updating order status:", error);
            toast.error("Error updating order status");
        }
    };

    // Update order quantity
    const updateOrderQuantity = async () => {
        try {
            if (!editQuantity || editQuantity <= 0) {
                toast.error("Please enter a valid quantity");
                return;
            }

            const data = new FormData();
            data.append("order_id", selectedOrder.order_id);
            data.append("quantity", editQuantity);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/update_order_quantity.php", {
                method: "POST",
                body: data
            });

            const result = await response.json();

            if (result.status === "success") {
                toast.success("Order quantity updated successfully");
                setShowModal(false);
                // Refresh the orders list
                window.location.reload();
            } else {
                toast.error(result.message || "Failed to update order quantity");
            }
        } catch (error) {
            console.error("Error updating order quantity:", error);
            toast.error("Error updating order quantity");
        }
    };

    // Download invoice
    // const downloadInvoice = async (orderId) => {
    //     try {
    //         toast.info("Generating invoice...");

    //         const data = new FormData();
    //         data.append("order_id", orderId);

    //         const response = await fetch("https://leapatinternational.com/admin/api/v1/invoice.php", {
    //             method: "POST",
    //             body: data
    //         });

    //         console.log("Download response:", response);

    //         if (response.ok) {
    //             // Parse JSON response
    //             const result = await response.json();
    //             console.log("Invoice API result:", result);

    //             if (result.status === "success" && result.invoice_url) {
    //                 // Open the invoice URL in a new tab/window
    //                 window.open(result.invoice_url, '_blank');
    //                 toast.success("Invoice opened successfully!");

    //                 // Optional: Also try to trigger download
    //                 // You can uncomment this if you want to force download
    //                 /*
    //                 try {
    //                     const link = document.createElement('a');
    //                     link.href = result.invoice_url;
    //                     link.download = `invoice_order_${orderId}.html`;
    //                     link.target = '_blank';
    //                     document.body.appendChild(link);
    //                     link.click();
    //                     document.body.removeChild(link);
    //                 } catch (downloadError) {
    //                     console.log("Direct download failed, but URL opened:", downloadError);
    //                 }
    //                 */
    //             } else {
    //                 toast.error(result.message || "Failed to generate invoice");
    //             }
    //         } else {
    //             const errorText = await response.text();
    //             console.error("Invoice generation failed:", errorText);
    //             toast.error("Failed to generate invoice");
    //         }
    //     } catch (error) {
    //         console.error("Error generating invoice:", error);
    //         toast.error("Error generating invoice: " + error.message);
    //     }
    // };
    // Alternative with html2pdf.js library



    // const downloadInvoice = async (orderId) => {
    //     // Constants
    //     const API_URL = "https://leapatinternational.com/admin/api/v1/invoice.php";
    //     const TIMEOUT_MS = 30000; // 30 seconds timeout
    //     try {
    //         if (!orderId || typeof orderId !== 'string') {
    //             throw new Error("Invalid order ID");
    //         }

    //         toast.info("Generating PDF...", { toastId: 'pdf-generation' });

    //         // Step 1: Get invoice PDF URL
    //         const formData = new FormData();
    //         formData.append("order_id", orderId);

    //         const response = await fetch(API_URL, {
    //             method: "POST",
    //             body: formData
    //         });

    //         if (!response.ok || response.status === 0) {
    //             throw new Error("Failed to generate invoice. Please try again.");
    //         }

    //         const result = await response.json();
    //         console.log(result);
    //         if (result.status !== "success" || !result.invoice_url) {
    //             console.log("object");
    //             throw new Error(result.message || "Invoice information not available");
    //         }

    //         // Step 2: Download the PDF directly
    //         const pdfUrl = result.invoice_url;
    //         console.log(pdfUrl);

    //         // Create a temporary anchor element to trigger download
    //         const a = document.createElement('a');
    //         a.href = pdfUrl;
    //         a.download = `invoice_${orderId}.pdf`;
    //         a.target = '_blank'; // Open in new tab if download doesn't work
    //         document.body.appendChild(a);
    //         a.click();
    //         // Cleanup
    //         setTimeout(() => {
    //             document.body.removeChild(a);
    //             URL.revokeObjectURL(pdfUrl);
    //         }, 100);

    //         toast.success("PDF downloaded successfully!");

    //     } catch (error) {
    //         console.error("PDF Download Error:", error);
    //         toast.error(`Failed to download invoice: ${error.message}`, {
    //             autoClose: 10000,
    //             toastId: 'pdf-error'
    //         });
    //     }
    // };

    const downloadInvoice = async (orderId) => {
        const API_URL = "https://leapatinternational.com/admin/api/v1/invoice.php";
        const TIMEOUT_MS = 30000;

        if (!orderId || typeof orderId !== 'string') {
            toast.error("Invalid order ID");
            return;
        }

        toast.info("Generating invoice...", { toastId: 'pdf-generation' });

        try {
            const formData = new FormData();
            formData.append("order_id", orderId);

            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS);

            const response = await fetch(API_URL, {
                method: "POST",
                body: formData,
                signal: controller.signal
            });

            clearTimeout(timeout);

            if (!response.ok) {
                throw new Error("Invoice generation failed. Try again.");
            }

            const result = await response.json();

            if (result.status !== "success" || !result.invoice_url) {
                throw new Error(result.message || "Invoice URL not received.");
            }

            // Fetch the actual PDF file as a Blob
            const fileResponse = await fetch(result.invoice_url);
            const blob = await fileResponse.blob();

            // Create a blob URL and trigger a download
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `invoice_${orderId}.pdf`; // Optional: customize file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl); // Clean up

            toast.success("Invoice downloaded!");

        } catch (error) {
            console.error("Invoice Download Error:", error);
            const errMsg =
                error.name === 'AbortError'
                    ? "Invoice request timed out."
                    : error.message || "Something went wrong.";

            toast.error(`Download failed: ${errMsg}`, {
                autoClose: 8000,
                toastId: 'invoice-download-error',
            });
        }
    };




    const handleEditOrder = async (order) => {
        setSelectedOrder(order);
        setShowModal(true);
        await getOrderDetails(order.order_id);
    };

    const handleApprove = (orderId) => {
        if (window.confirm("Are you sure you want to approve this order?")) {
            updateOrderStatus(orderId, "1");
        }
    };

    const handleReject = (orderId) => {
        if (window.confirm("Are you sure you want to reject this order?")) {
            updateOrderStatus(orderId, "2");
        }
    };

    const getStatusBadge = (status) => {
        const statusLower = status?.toLowerCase();
        let badgeClass = "badge ";

        switch (statusLower) {
            case 'pending':
                badgeClass += "bg-warning text-dark rounded-pill";
                break;
            case 'approved':
            case 'completed':
                badgeClass += "bg-success rounded-pill";
                break;
            case 'rejected':
            case 'cancelled':
                badgeClass += "bg-danger rounded-pill";
                break;
            case 'processing':
                badgeClass += "bg-info rounded-pill";
                break;
            default:
                badgeClass += "bg-secondary rounded-pill";
        }

        return <span className={badgeClass}>{status}</span>;
    };

    if (loading) {
        return (
            <div className="category-management-section">
                <div className="loading-spinner">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="category-management-section">
                <div className="alert alert-danger" role="alert">
                    Error: {error}
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="category-management-section">
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h1 className="page-title">Orders</h1>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Orders Table */}
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title mb-0">Order List</h5>
                            </div>
                            <div className="card-body">
                                {data?.length > 0 ? (
                                    <div className="content-table">
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '5%' }}>Id</th>
                                                        <th style={{ width: '15%' }}>User Name</th>
                                                        <th style={{ width: '20%' }}>Item Name</th>
                                                        <th style={{ width: '10%' }}>Qty</th>
                                                        <th style={{ width: '10%' }}>Price</th>
                                                        <th style={{ width: '10%' }}>Status</th>
                                                        <th style={{ width: '20%' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.map((item) => (
                                                        <tr key={item.order_id}>
                                                            <td>
                                                                <h6 className="content-title">{item.order_id}</h6>
                                                            </td>
                                                            <td>
                                                                <div className="content-info">
                                                                    <h6 className="content-title">{item.username}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="content-info">
                                                                    <h6 className="content-title">{item.product_name}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h6 className="content-title">{item.quantity}</h6>
                                                            </td>
                                                            <td>
                                                                <h6 className="content-title">₹{parseFloat(item.price).toLocaleString('en-IN')}</h6>
                                                            </td>
                                                            <td>
                                                                {getStatusBadge(item.status)}
                                                            </td>
                                                            <td>
                                                                <div className="action-buttons d-flex gap-1 flex-wrap">
                                                                    <button
                                                                        className="btn btn-sm btn-outline-primary"
                                                                        title="Edit Quantity"
                                                                        onClick={() => handleEditOrder(item)}
                                                                    >
                                                                        ✏️
                                                                    </button>

                                                                    <button
                                                                        className="btn btn-sm btn-outline-success"
                                                                        title="Download Invoice"
                                                                        onClick={() => downloadInvoice(item.order_id)}
                                                                    >
                                                                        ⬇️
                                                                    </button>

                                                                    {/* Show Approve/Reject buttons only for pending orders */}
                                                                    {item.status?.toLowerCase() === 'pending' && (
                                                                        <>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-success"
                                                                                title="Approve Order"
                                                                                onClick={() => handleApprove(item.order_id)}
                                                                            >
                                                                                ✅
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-danger"
                                                                                title="Reject Order"
                                                                                onClick={() => handleReject(item.order_id)}
                                                                            >
                                                                                ❌
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="empty-state">
                                            <div className="empty-icon">📂</div>
                                            <h5>No orders found</h5>
                                            <p className="text-muted">
                                                {searchQuery ? `No orders match "${searchQuery}"` : "No orders available"}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Order Modal */}
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Order Quantity</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {modalLoading ? (
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : orderDetails ? (
                                    <div>
                                        <div className="mb-3">
                                            <strong>Order ID:</strong> {orderDetails.order_id}
                                        </div>
                                        <div className="mb-3">
                                            <strong>Product:</strong> {orderDetails.product_name}
                                        </div>
                                        <div className="mb-3">
                                            <strong>Current Quantity:</strong> {orderDetails.quantity}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="editQuantity" className="form-label">
                                                <strong>New Quantity:</strong>
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="editQuantity"
                                                value={editQuantity}
                                                onChange={(e) => setEditQuantity(e.target.value)}
                                                min="1"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center text-danger">
                                        Failed to load order details
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={updateOrderQuantity}
                                    disabled={modalLoading || !orderDetails}
                                >
                                    Update Quantity
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}